import styles from './PurchaseOrdersListFilters.module.css';
import { Select } from '@round/whitelabel-ui';
import { SearchInput } from '@round/whitelabel-ui';
import useTeamSelect from 'Modules/Plans/Team/hooks/useTeamSelect';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';
import { UrlState } from '../../usePurchaseOrdersListUrlState';
import ProjectSelect from 'Modules/Plans/Project/components/ProjectSelect/ProjectSelect';
import useProjectSelect from 'Modules/Plans/Project/hooks/useProjectSelect';
import useBillingEntitySelect, {
    mapBillingEntityToOption,
} from 'Modules/Plans/Finance/BillingEntities/hooks/useBillingEntitySelect';
import cn from 'classnames';
import { useBillingEntity } from '@round/creatorbase-helpers/api-hooks';

type FilterValues = Pick<UrlState, 'search' | 'team' | 'project' | 'billingEntity'>;

type Props = {
    filters: FilterValues;
    onFiltersChange: (filters: FilterValues) => void;
    className?: string;
};

const PurchaseOrdersListFilters = ({ filters, onFiltersChange, className }: Props) => {
    const { selectedClientId } = useClientSelect();

    const { getProps: getTeamSelectProps } = useTeamSelect({
        initOn: 'menuOpen',
        initialValueId: filters.team ? Number(filters.team) : undefined,
        params: { client_id: selectedClientId },
        enabled: typeof selectedClientId === 'number',
    });

    const { getProps: getProjectSelectProps } = useProjectSelect({
        initOn: 'menuOpen',
        initialValueId: filters.project ? Number(filters.project) : undefined,
        params: { client_id: selectedClientId },
        enabled: typeof selectedClientId === 'number',
    });

    const { data: initialBillingEntity } = useBillingEntity(filters.billingEntity);

    const { getProps: getBillingEntitiesSelectProps } = useBillingEntitySelect({
        initialValue: initialBillingEntity ? mapBillingEntityToOption(initialBillingEntity) : undefined,
        params: { client_id: selectedClientId },
        enabled: typeof selectedClientId === 'number',
    });

    return (
        <div className={cn(styles.container, className)}>
            <SearchInput value={filters.search || ''} onChange={(value) => onFiltersChange({ search: value })} />

            <Select
                {...getTeamSelectProps()}
                onChange={(option) => onFiltersChange({ team: option?.value })}
                placeholder="Select team..."
                isClearable
                className={styles.select}
            />

            <ProjectSelect
                {...getProjectSelectProps()}
                onChange={(option) => onFiltersChange({ project: option?.value })}
                isClearable
                className={styles.select}
            />

            <Select
                {...getBillingEntitiesSelectProps()}
                onChange={(option) => onFiltersChange({ billingEntity: option?.value })}
                placeholder="Select billing entity..."
                isClearable
                className={styles.select}
            />
        </div>
    );
};

export default PurchaseOrdersListFilters;
